// Comprehensive list of countries with their states/provinces
export const COUNTRIES = [
  { code: 'US', name: 'United States', hasStates: true },
  { code: 'CA', name: 'Canada', hasStates: true },
  { code: 'GB', name: 'United Kingdom', hasStates: false },
  { code: 'AU', name: 'Australia', hasStates: true },
  { code: 'DE', name: 'Germany', hasStates: true },
  { code: 'FR', name: 'France', hasStates: false },
  { code: 'IT', name: 'Italy', hasStates: false },
  { code: 'ES', name: 'Spain', hasStates: false },
  { code: 'MX', name: 'Mexico', hasStates: true },
  { code: 'BR', name: 'Brazil', hasStates: true },
  { code: 'JP', name: 'Japan', hasStates: true },
  { code: 'KR', name: 'South Korea', hasStates: false },
  { code: 'CN', name: 'China', hasStates: true },
  { code: 'IN', name: 'India', hasStates: true },
  { code: 'RU', name: 'Russia', hasStates: false },
  { code: 'NL', name: 'Netherlands', hasStates: false },
  { code: 'BE', name: 'Belgium', hasStates: false },
  { code: 'SE', name: 'Sweden', hasStates: false },
  { code: 'NO', name: 'Norway', hasStates: false },
  { code: 'DK', name: 'Denmark', hasStates: false },
  { code: 'FI', name: 'Finland', hasStates: false },
  { code: 'AT', name: 'Austria', hasStates: false },
  { code: 'CH', name: 'Switzerland', hasStates: true },
  { code: 'PL', name: 'Poland', hasStates: false },
  { code: 'PT', name: 'Portugal', hasStates: false },
  { code: 'IE', name: 'Ireland', hasStates: false },
  { code: 'NZ', name: 'New Zealand', hasStates: false },
  { code: 'SG', name: 'Singapore', hasStates: false },
  { code: 'HK', name: 'Hong Kong', hasStates: false },
  { code: 'TW', name: 'Taiwan', hasStates: false },
  { code: 'TH', name: 'Thailand', hasStates: false },
  { code: 'MY', name: 'Malaysia', hasStates: true },
  { code: 'PH', name: 'Philippines', hasStates: false },
  { code: 'ID', name: 'Indonesia', hasStates: true },
  { code: 'VN', name: 'Vietnam', hasStates: false },
  { code: 'ZA', name: 'South Africa', hasStates: true },
  { code: 'AE', name: 'United Arab Emirates', hasStates: false },
  { code: 'SA', name: 'Saudi Arabia', hasStates: false },
  { code: 'IL', name: 'Israel', hasStates: false },
  { code: 'TR', name: 'Turkey', hasStates: false },
  { code: 'EG', name: 'Egypt', hasStates: false },
  { code: 'AR', name: 'Argentina', hasStates: true },
  { code: 'CL', name: 'Chile', hasStates: false },
  { code: 'CO', name: 'Colombia', hasStates: false },
  { code: 'PE', name: 'Peru', hasStates: false },
  { code: 'VE', name: 'Venezuela', hasStates: false },
  { code: 'EC', name: 'Ecuador', hasStates: false },
  { code: 'CR', name: 'Costa Rica', hasStates: false },
  { code: 'PA', name: 'Panama', hasStates: false },
  { code: 'DO', name: 'Dominican Republic', hasStates: false },
  { code: 'PR', name: 'Puerto Rico', hasStates: false },
  { code: 'JM', name: 'Jamaica', hasStates: false },
  { code: 'CU', name: 'Cuba', hasStates: false },
  { code: 'GT', name: 'Guatemala', hasStates: false },
  { code: 'HN', name: 'Honduras', hasStates: false },
  { code: 'SV', name: 'El Salvador', hasStates: false },
  { code: 'NI', name: 'Nicaragua', hasStates: false },
  { code: 'BO', name: 'Bolivia', hasStates: false },
  { code: 'PY', name: 'Paraguay', hasStates: false },
  { code: 'UY', name: 'Uruguay', hasStates: false },
  { code: 'CZ', name: 'Czech Republic', hasStates: false },
  { code: 'SK', name: 'Slovakia', hasStates: false },
  { code: 'HU', name: 'Hungary', hasStates: false },
  { code: 'RO', name: 'Romania', hasStates: false },
  { code: 'BG', name: 'Bulgaria', hasStates: false },
  { code: 'HR', name: 'Croatia', hasStates: false },
  { code: 'SI', name: 'Slovenia', hasStates: false },
  { code: 'RS', name: 'Serbia', hasStates: false },
  { code: 'BA', name: 'Bosnia and Herzegovina', hasStates: false },
  { code: 'MK', name: 'North Macedonia', hasStates: false },
  { code: 'AL', name: 'Albania', hasStates: false },
  { code: 'ME', name: 'Montenegro', hasStates: false },
  { code: 'XK', name: 'Kosovo', hasStates: false },
  { code: 'GR', name: 'Greece', hasStates: false },
  { code: 'CY', name: 'Cyprus', hasStates: false },
  { code: 'MT', name: 'Malta', hasStates: false },
  { code: 'LU', name: 'Luxembourg', hasStates: false },
  { code: 'IS', name: 'Iceland', hasStates: false },
  { code: 'EE', name: 'Estonia', hasStates: false },
  { code: 'LV', name: 'Latvia', hasStates: false },
  { code: 'LT', name: 'Lithuania', hasStates: false },
  { code: 'UA', name: 'Ukraine', hasStates: false },
  { code: 'BY', name: 'Belarus', hasStates: false },
  { code: 'MD', name: 'Moldova', hasStates: false },
  { code: 'GE', name: 'Georgia', hasStates: false },
  { code: 'AM', name: 'Armenia', hasStates: false },
  { code: 'AZ', name: 'Azerbaijan', hasStates: false },
  { code: 'KZ', name: 'Kazakhstan', hasStates: false },
  { code: 'UZ', name: 'Uzbekistan', hasStates: false },
  { code: 'TM', name: 'Turkmenistan', hasStates: false },
  { code: 'KG', name: 'Kyrgyzstan', hasStates: false },
  { code: 'TJ', name: 'Tajikistan', hasStates: false },
  { code: 'MN', name: 'Mongolia', hasStates: false },
  { code: 'NP', name: 'Nepal', hasStates: false },
  { code: 'BD', name: 'Bangladesh', hasStates: false },
  { code: 'LK', name: 'Sri Lanka', hasStates: false },
  { code: 'PK', name: 'Pakistan', hasStates: true },
  { code: 'AF', name: 'Afghanistan', hasStates: false },
  { code: 'MM', name: 'Myanmar', hasStates: false },
  { code: 'KH', name: 'Cambodia', hasStates: false },
  { code: 'LA', name: 'Laos', hasStates: false },
  { code: 'BN', name: 'Brunei', hasStates: false },
  { code: 'MV', name: 'Maldives', hasStates: false },
  { code: 'BT', name: 'Bhutan', hasStates: false },
  { code: 'KW', name: 'Kuwait', hasStates: false },
  { code: 'QA', name: 'Qatar', hasStates: false },
  { code: 'BH', name: 'Bahrain', hasStates: false },
  { code: 'OM', name: 'Oman', hasStates: false },
  { code: 'YE', name: 'Yemen', hasStates: false },
  { code: 'JO', name: 'Jordan', hasStates: false },
  { code: 'LB', name: 'Lebanon', hasStates: false },
  { code: 'SY', name: 'Syria', hasStates: false },
  { code: 'IQ', name: 'Iraq', hasStates: false },
  { code: 'IR', name: 'Iran', hasStates: false },
  { code: 'MA', name: 'Morocco', hasStates: false },
  { code: 'DZ', name: 'Algeria', hasStates: false },
  { code: 'TN', name: 'Tunisia', hasStates: false },
  { code: 'LY', name: 'Libya', hasStates: false },
  { code: 'SD', name: 'Sudan', hasStates: false },
  { code: 'ET', name: 'Ethiopia', hasStates: false },
  { code: 'KE', name: 'Kenya', hasStates: false },
  { code: 'TZ', name: 'Tanzania', hasStates: false },
  { code: 'UG', name: 'Uganda', hasStates: false },
  { code: 'RW', name: 'Rwanda', hasStates: false },
  { code: 'NG', name: 'Nigeria', hasStates: true },
  { code: 'GH', name: 'Ghana', hasStates: false },
  { code: 'CI', name: 'Ivory Coast', hasStates: false },
  { code: 'SN', name: 'Senegal', hasStates: false },
  { code: 'CM', name: 'Cameroon', hasStates: false },
  { code: 'AO', name: 'Angola', hasStates: false },
  { code: 'MZ', name: 'Mozambique', hasStates: false },
  { code: 'ZW', name: 'Zimbabwe', hasStates: false },
  { code: 'ZM', name: 'Zambia', hasStates: false },
  { code: 'BW', name: 'Botswana', hasStates: false },
  { code: 'NA', name: 'Namibia', hasStates: false },
  { code: 'MU', name: 'Mauritius', hasStates: false },
  { code: 'MG', name: 'Madagascar', hasStates: false },
  { code: 'FJ', name: 'Fiji', hasStates: false },
  { code: 'PG', name: 'Papua New Guinea', hasStates: false },
  { code: 'GU', name: 'Guam', hasStates: false },
  { code: 'VI', name: 'U.S. Virgin Islands', hasStates: false },
  { code: 'AS', name: 'American Samoa', hasStates: false },
  { code: 'MP', name: 'Northern Mariana Islands', hasStates: false },
  // Military addresses
  { code: 'AA', name: 'Armed Forces Americas (AA)', hasStates: false, isMilitary: true },
  { code: 'AE_MIL', name: 'Armed Forces Europe/Middle East/Africa (AE)', hasStates: false, isMilitary: true },
  { code: 'AP', name: 'Armed Forces Pacific (AP)', hasStates: false, isMilitary: true },
].sort((a, b) => {
  // Put military at the end
  if (a.isMilitary && !b.isMilitary) return 1;
  if (!a.isMilitary && b.isMilitary) return -1;
  return a.name.localeCompare(b.name);
});

export const STATES_BY_COUNTRY = {
  US: [
    { code: 'AL', name: 'Alabama' },
    { code: 'AK', name: 'Alaska' },
    { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' },
    { code: 'CA', name: 'California' },
    { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' },
    { code: 'DE', name: 'Delaware' },
    { code: 'DC', name: 'District of Columbia' },
    { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' },
    { code: 'HI', name: 'Hawaii' },
    { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' },
    { code: 'IN', name: 'Indiana' },
    { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' },
    { code: 'KY', name: 'Kentucky' },
    { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' },
    { code: 'MD', name: 'Maryland' },
    { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' },
    { code: 'MN', name: 'Minnesota' },
    { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' },
    { code: 'MT', name: 'Montana' },
    { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' },
    { code: 'NH', name: 'New Hampshire' },
    { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' },
    { code: 'NY', name: 'New York' },
    { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' },
    { code: 'OH', name: 'Ohio' },
    { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' },
    { code: 'PA', name: 'Pennsylvania' },
    { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' },
    { code: 'SD', name: 'South Dakota' },
    { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' },
    { code: 'UT', name: 'Utah' },
    { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' },
    { code: 'WA', name: 'Washington' },
    { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' },
    { code: 'WY', name: 'Wyoming' },
  ],
  CA: [
    { code: 'AB', name: 'Alberta' },
    { code: 'BC', name: 'British Columbia' },
    { code: 'MB', name: 'Manitoba' },
    { code: 'NB', name: 'New Brunswick' },
    { code: 'NL', name: 'Newfoundland and Labrador' },
    { code: 'NS', name: 'Nova Scotia' },
    { code: 'NT', name: 'Northwest Territories' },
    { code: 'NU', name: 'Nunavut' },
    { code: 'ON', name: 'Ontario' },
    { code: 'PE', name: 'Prince Edward Island' },
    { code: 'QC', name: 'Quebec' },
    { code: 'SK', name: 'Saskatchewan' },
    { code: 'YT', name: 'Yukon' },
  ],
  AU: [
    { code: 'ACT', name: 'Australian Capital Territory' },
    { code: 'NSW', name: 'New South Wales' },
    { code: 'NT', name: 'Northern Territory' },
    { code: 'QLD', name: 'Queensland' },
    { code: 'SA', name: 'South Australia' },
    { code: 'TAS', name: 'Tasmania' },
    { code: 'VIC', name: 'Victoria' },
    { code: 'WA', name: 'Western Australia' },
  ],
  DE: [
    { code: 'BW', name: 'Baden-Württemberg' },
    { code: 'BY', name: 'Bavaria' },
    { code: 'BE', name: 'Berlin' },
    { code: 'BB', name: 'Brandenburg' },
    { code: 'HB', name: 'Bremen' },
    { code: 'HH', name: 'Hamburg' },
    { code: 'HE', name: 'Hesse' },
    { code: 'MV', name: 'Mecklenburg-Vorpommern' },
    { code: 'NI', name: 'Lower Saxony' },
    { code: 'NW', name: 'North Rhine-Westphalia' },
    { code: 'RP', name: 'Rhineland-Palatinate' },
    { code: 'SL', name: 'Saarland' },
    { code: 'SN', name: 'Saxony' },
    { code: 'ST', name: 'Saxony-Anhalt' },
    { code: 'SH', name: 'Schleswig-Holstein' },
    { code: 'TH', name: 'Thuringia' },
  ],
  MX: [
    { code: 'AGU', name: 'Aguascalientes' },
    { code: 'BCN', name: 'Baja California' },
    { code: 'BCS', name: 'Baja California Sur' },
    { code: 'CAM', name: 'Campeche' },
    { code: 'CHP', name: 'Chiapas' },
    { code: 'CHH', name: 'Chihuahua' },
    { code: 'COA', name: 'Coahuila' },
    { code: 'COL', name: 'Colima' },
    { code: 'CMX', name: 'Mexico City' },
    { code: 'DUR', name: 'Durango' },
    { code: 'GUA', name: 'Guanajuato' },
    { code: 'GRO', name: 'Guerrero' },
    { code: 'HID', name: 'Hidalgo' },
    { code: 'JAL', name: 'Jalisco' },
    { code: 'MEX', name: 'State of Mexico' },
    { code: 'MIC', name: 'Michoacán' },
    { code: 'MOR', name: 'Morelos' },
    { code: 'NAY', name: 'Nayarit' },
    { code: 'NLE', name: 'Nuevo León' },
    { code: 'OAX', name: 'Oaxaca' },
    { code: 'PUE', name: 'Puebla' },
    { code: 'QUE', name: 'Querétaro' },
    { code: 'ROO', name: 'Quintana Roo' },
    { code: 'SLP', name: 'San Luis Potosí' },
    { code: 'SIN', name: 'Sinaloa' },
    { code: 'SON', name: 'Sonora' },
    { code: 'TAB', name: 'Tabasco' },
    { code: 'TAM', name: 'Tamaulipas' },
    { code: 'TLA', name: 'Tlaxcala' },
    { code: 'VER', name: 'Veracruz' },
    { code: 'YUC', name: 'Yucatán' },
    { code: 'ZAC', name: 'Zacatecas' },
  ],
  BR: [
    { code: 'AC', name: 'Acre' },
    { code: 'AL', name: 'Alagoas' },
    { code: 'AP', name: 'Amapá' },
    { code: 'AM', name: 'Amazonas' },
    { code: 'BA', name: 'Bahia' },
    { code: 'CE', name: 'Ceará' },
    { code: 'DF', name: 'Federal District' },
    { code: 'ES', name: 'Espírito Santo' },
    { code: 'GO', name: 'Goiás' },
    { code: 'MA', name: 'Maranhão' },
    { code: 'MT', name: 'Mato Grosso' },
    { code: 'MS', name: 'Mato Grosso do Sul' },
    { code: 'MG', name: 'Minas Gerais' },
    { code: 'PA', name: 'Pará' },
    { code: 'PB', name: 'Paraíba' },
    { code: 'PR', name: 'Paraná' },
    { code: 'PE', name: 'Pernambuco' },
    { code: 'PI', name: 'Piauí' },
    { code: 'RJ', name: 'Rio de Janeiro' },
    { code: 'RN', name: 'Rio Grande do Norte' },
    { code: 'RS', name: 'Rio Grande do Sul' },
    { code: 'RO', name: 'Rondônia' },
    { code: 'RR', name: 'Roraima' },
    { code: 'SC', name: 'Santa Catarina' },
    { code: 'SP', name: 'São Paulo' },
    { code: 'SE', name: 'Sergipe' },
    { code: 'TO', name: 'Tocantins' },
  ],
  JP: [
    { code: '01', name: 'Hokkaido' },
    { code: '02', name: 'Aomori' },
    { code: '03', name: 'Iwate' },
    { code: '04', name: 'Miyagi' },
    { code: '05', name: 'Akita' },
    { code: '06', name: 'Yamagata' },
    { code: '07', name: 'Fukushima' },
    { code: '08', name: 'Ibaraki' },
    { code: '09', name: 'Tochigi' },
    { code: '10', name: 'Gunma' },
    { code: '11', name: 'Saitama' },
    { code: '12', name: 'Chiba' },
    { code: '13', name: 'Tokyo' },
    { code: '14', name: 'Kanagawa' },
    { code: '15', name: 'Niigata' },
    { code: '16', name: 'Toyama' },
    { code: '17', name: 'Ishikawa' },
    { code: '18', name: 'Fukui' },
    { code: '19', name: 'Yamanashi' },
    { code: '20', name: 'Nagano' },
    { code: '21', name: 'Gifu' },
    { code: '22', name: 'Shizuoka' },
    { code: '23', name: 'Aichi' },
    { code: '24', name: 'Mie' },
    { code: '25', name: 'Shiga' },
    { code: '26', name: 'Kyoto' },
    { code: '27', name: 'Osaka' },
    { code: '28', name: 'Hyogo' },
    { code: '29', name: 'Nara' },
    { code: '30', name: 'Wakayama' },
    { code: '31', name: 'Tottori' },
    { code: '32', name: 'Shimane' },
    { code: '33', name: 'Okayama' },
    { code: '34', name: 'Hiroshima' },
    { code: '35', name: 'Yamaguchi' },
    { code: '36', name: 'Tokushima' },
    { code: '37', name: 'Kagawa' },
    { code: '38', name: 'Ehime' },
    { code: '39', name: 'Kochi' },
    { code: '40', name: 'Fukuoka' },
    { code: '41', name: 'Saga' },
    { code: '42', name: 'Nagasaki' },
    { code: '43', name: 'Kumamoto' },
    { code: '44', name: 'Oita' },
    { code: '45', name: 'Miyazaki' },
    { code: '46', name: 'Kagoshima' },
    { code: '47', name: 'Okinawa' },
  ],
  CN: [
    { code: 'AH', name: 'Anhui' },
    { code: 'BJ', name: 'Beijing' },
    { code: 'CQ', name: 'Chongqing' },
    { code: 'FJ', name: 'Fujian' },
    { code: 'GS', name: 'Gansu' },
    { code: 'GD', name: 'Guangdong' },
    { code: 'GX', name: 'Guangxi' },
    { code: 'GZ', name: 'Guizhou' },
    { code: 'HI', name: 'Hainan' },
    { code: 'HE', name: 'Hebei' },
    { code: 'HL', name: 'Heilongjiang' },
    { code: 'HA', name: 'Henan' },
    { code: 'HB', name: 'Hubei' },
    { code: 'HN', name: 'Hunan' },
    { code: 'JS', name: 'Jiangsu' },
    { code: 'JX', name: 'Jiangxi' },
    { code: 'JL', name: 'Jilin' },
    { code: 'LN', name: 'Liaoning' },
    { code: 'NM', name: 'Inner Mongolia' },
    { code: 'NX', name: 'Ningxia' },
    { code: 'QH', name: 'Qinghai' },
    { code: 'SN', name: 'Shaanxi' },
    { code: 'SD', name: 'Shandong' },
    { code: 'SH', name: 'Shanghai' },
    { code: 'SX', name: 'Shanxi' },
    { code: 'SC', name: 'Sichuan' },
    { code: 'TJ', name: 'Tianjin' },
    { code: 'XJ', name: 'Xinjiang' },
    { code: 'XZ', name: 'Tibet' },
    { code: 'YN', name: 'Yunnan' },
    { code: 'ZJ', name: 'Zhejiang' },
  ],
  IN: [
    { code: 'AN', name: 'Andaman and Nicobar Islands' },
    { code: 'AP', name: 'Andhra Pradesh' },
    { code: 'AR', name: 'Arunachal Pradesh' },
    { code: 'AS', name: 'Assam' },
    { code: 'BR', name: 'Bihar' },
    { code: 'CH', name: 'Chandigarh' },
    { code: 'CT', name: 'Chhattisgarh' },
    { code: 'DN', name: 'Dadra and Nagar Haveli' },
    { code: 'DD', name: 'Daman and Diu' },
    { code: 'DL', name: 'Delhi' },
    { code: 'GA', name: 'Goa' },
    { code: 'GJ', name: 'Gujarat' },
    { code: 'HR', name: 'Haryana' },
    { code: 'HP', name: 'Himachal Pradesh' },
    { code: 'JK', name: 'Jammu and Kashmir' },
    { code: 'JH', name: 'Jharkhand' },
    { code: 'KA', name: 'Karnataka' },
    { code: 'KL', name: 'Kerala' },
    { code: 'LA', name: 'Ladakh' },
    { code: 'LD', name: 'Lakshadweep' },
    { code: 'MP', name: 'Madhya Pradesh' },
    { code: 'MH', name: 'Maharashtra' },
    { code: 'MN', name: 'Manipur' },
    { code: 'ML', name: 'Meghalaya' },
    { code: 'MZ', name: 'Mizoram' },
    { code: 'NL', name: 'Nagaland' },
    { code: 'OR', name: 'Odisha' },
    { code: 'PY', name: 'Puducherry' },
    { code: 'PB', name: 'Punjab' },
    { code: 'RJ', name: 'Rajasthan' },
    { code: 'SK', name: 'Sikkim' },
    { code: 'TN', name: 'Tamil Nadu' },
    { code: 'TG', name: 'Telangana' },
    { code: 'TR', name: 'Tripura' },
    { code: 'UP', name: 'Uttar Pradesh' },
    { code: 'UT', name: 'Uttarakhand' },
    { code: 'WB', name: 'West Bengal' },
  ],
  CH: [
    { code: 'AG', name: 'Aargau' },
    { code: 'AR', name: 'Appenzell Ausserrhoden' },
    { code: 'AI', name: 'Appenzell Innerrhoden' },
    { code: 'BL', name: 'Basel-Landschaft' },
    { code: 'BS', name: 'Basel-Stadt' },
    { code: 'BE', name: 'Bern' },
    { code: 'FR', name: 'Fribourg' },
    { code: 'GE', name: 'Geneva' },
    { code: 'GL', name: 'Glarus' },
    { code: 'GR', name: 'Graubünden' },
    { code: 'JU', name: 'Jura' },
    { code: 'LU', name: 'Lucerne' },
    { code: 'NE', name: 'Neuchâtel' },
    { code: 'NW', name: 'Nidwalden' },
    { code: 'OW', name: 'Obwalden' },
    { code: 'SH', name: 'Schaffhausen' },
    { code: 'SZ', name: 'Schwyz' },
    { code: 'SO', name: 'Solothurn' },
    { code: 'SG', name: 'St. Gallen' },
    { code: 'TG', name: 'Thurgau' },
    { code: 'TI', name: 'Ticino' },
    { code: 'UR', name: 'Uri' },
    { code: 'VS', name: 'Valais' },
    { code: 'VD', name: 'Vaud' },
    { code: 'ZG', name: 'Zug' },
    { code: 'ZH', name: 'Zürich' },
  ],
  MY: [
    { code: 'JHR', name: 'Johor' },
    { code: 'KDH', name: 'Kedah' },
    { code: 'KTN', name: 'Kelantan' },
    { code: 'KUL', name: 'Kuala Lumpur' },
    { code: 'LBN', name: 'Labuan' },
    { code: 'MLK', name: 'Malacca' },
    { code: 'NSN', name: 'Negeri Sembilan' },
    { code: 'PHG', name: 'Pahang' },
    { code: 'PRK', name: 'Perak' },
    { code: 'PLS', name: 'Perlis' },
    { code: 'PNG', name: 'Penang' },
    { code: 'PJY', name: 'Putrajaya' },
    { code: 'SBH', name: 'Sabah' },
    { code: 'SWK', name: 'Sarawak' },
    { code: 'SGR', name: 'Selangor' },
    { code: 'TRG', name: 'Terengganu' },
  ],
  ID: [
    { code: 'AC', name: 'Aceh' },
    { code: 'BA', name: 'Bali' },
    { code: 'BB', name: 'Bangka Belitung Islands' },
    { code: 'BT', name: 'Banten' },
    { code: 'BE', name: 'Bengkulu' },
    { code: 'GO', name: 'Gorontalo' },
    { code: 'JK', name: 'Jakarta' },
    { code: 'JA', name: 'Jambi' },
    { code: 'JB', name: 'West Java' },
    { code: 'JT', name: 'Central Java' },
    { code: 'JI', name: 'East Java' },
    { code: 'KB', name: 'West Kalimantan' },
    { code: 'KS', name: 'South Kalimantan' },
    { code: 'KT', name: 'Central Kalimantan' },
    { code: 'KI', name: 'East Kalimantan' },
    { code: 'KU', name: 'North Kalimantan' },
    { code: 'KR', name: 'Riau Islands' },
    { code: 'LA', name: 'Lampung' },
    { code: 'MA', name: 'Maluku' },
    { code: 'MU', name: 'North Maluku' },
    { code: 'NB', name: 'West Nusa Tenggara' },
    { code: 'NT', name: 'East Nusa Tenggara' },
    { code: 'PA', name: 'Papua' },
    { code: 'PB', name: 'West Papua' },
    { code: 'RI', name: 'Riau' },
    { code: 'SR', name: 'West Sulawesi' },
    { code: 'SN', name: 'South Sulawesi' },
    { code: 'ST', name: 'Central Sulawesi' },
    { code: 'SG', name: 'Southeast Sulawesi' },
    { code: 'SA', name: 'North Sulawesi' },
    { code: 'SB', name: 'West Sumatra' },
    { code: 'SS', name: 'South Sumatra' },
    { code: 'SU', name: 'North Sumatra' },
    { code: 'YO', name: 'Yogyakarta' },
  ],
  ZA: [
    { code: 'EC', name: 'Eastern Cape' },
    { code: 'FS', name: 'Free State' },
    { code: 'GP', name: 'Gauteng' },
    { code: 'KZN', name: 'KwaZulu-Natal' },
    { code: 'LP', name: 'Limpopo' },
    { code: 'MP', name: 'Mpumalanga' },
    { code: 'NC', name: 'Northern Cape' },
    { code: 'NW', name: 'North West' },
    { code: 'WC', name: 'Western Cape' },
  ],
  AR: [
    { code: 'C', name: 'Buenos Aires City' },
    { code: 'B', name: 'Buenos Aires Province' },
    { code: 'K', name: 'Catamarca' },
    { code: 'H', name: 'Chaco' },
    { code: 'U', name: 'Chubut' },
    { code: 'X', name: 'Córdoba' },
    { code: 'W', name: 'Corrientes' },
    { code: 'E', name: 'Entre Ríos' },
    { code: 'P', name: 'Formosa' },
    { code: 'Y', name: 'Jujuy' },
    { code: 'L', name: 'La Pampa' },
    { code: 'F', name: 'La Rioja' },
    { code: 'M', name: 'Mendoza' },
    { code: 'N', name: 'Misiones' },
    { code: 'Q', name: 'Neuquén' },
    { code: 'R', name: 'Río Negro' },
    { code: 'A', name: 'Salta' },
    { code: 'J', name: 'San Juan' },
    { code: 'D', name: 'San Luis' },
    { code: 'Z', name: 'Santa Cruz' },
    { code: 'S', name: 'Santa Fe' },
    { code: 'G', name: 'Santiago del Estero' },
    { code: 'V', name: 'Tierra del Fuego' },
    { code: 'T', name: 'Tucumán' },
  ],
  PK: [
    { code: 'IS', name: 'Islamabad' },
    { code: 'PB', name: 'Punjab' },
    { code: 'SD', name: 'Sindh' },
    { code: 'KP', name: 'Khyber Pakhtunkhwa' },
    { code: 'BA', name: 'Balochistan' },
    { code: 'GB', name: 'Gilgit-Baltistan' },
    { code: 'AK', name: 'Azad Kashmir' },
  ],
  NG: [
    { code: 'AB', name: 'Abia' },
    { code: 'AD', name: 'Adamawa' },
    { code: 'AK', name: 'Akwa Ibom' },
    { code: 'AN', name: 'Anambra' },
    { code: 'BA', name: 'Bauchi' },
    { code: 'BY', name: 'Bayelsa' },
    { code: 'BE', name: 'Benue' },
    { code: 'BO', name: 'Borno' },
    { code: 'CR', name: 'Cross River' },
    { code: 'DE', name: 'Delta' },
    { code: 'EB', name: 'Ebonyi' },
    { code: 'ED', name: 'Edo' },
    { code: 'EK', name: 'Ekiti' },
    { code: 'EN', name: 'Enugu' },
    { code: 'FC', name: 'FCT' },
    { code: 'GO', name: 'Gombe' },
    { code: 'IM', name: 'Imo' },
    { code: 'JI', name: 'Jigawa' },
    { code: 'KD', name: 'Kaduna' },
    { code: 'KN', name: 'Kano' },
    { code: 'KT', name: 'Katsina' },
    { code: 'KE', name: 'Kebbi' },
    { code: 'KO', name: 'Kogi' },
    { code: 'KW', name: 'Kwara' },
    { code: 'LA', name: 'Lagos' },
    { code: 'NA', name: 'Nasarawa' },
    { code: 'NI', name: 'Niger' },
    { code: 'OG', name: 'Ogun' },
    { code: 'ON', name: 'Ondo' },
    { code: 'OS', name: 'Osun' },
    { code: 'OY', name: 'Oyo' },
    { code: 'PL', name: 'Plateau' },
    { code: 'RI', name: 'Rivers' },
    { code: 'SO', name: 'Sokoto' },
    { code: 'TA', name: 'Taraba' },
    { code: 'YO', name: 'Yobe' },
    { code: 'ZA', name: 'Zamfara' },
  ],
};

export const getStatesForCountry = (countryCode) => {
  return STATES_BY_COUNTRY[countryCode] || [];
};

export const countryHasStates = (countryCode) => {
  const country = COUNTRIES.find(c => c.code === countryCode);
  return country?.hasStates || false;
};
